interface EditorPanelObjectMaskOptions {
	param: StringParam;
}
import {CoreGraphNodeId} from '../../../../../@polygonjs/polygonjs/src/core/graph/CoreGraph';
import {ref, Ref} from 'vue';
import {StringParam} from '../../../../../@polygonjs/polygonjs/src/engine/params/String';
export class EditorPanelObjectMaskStoreControllerClass {
	private static _instance: EditorPanelObjectMaskStoreControllerClass;
	static instance() {
		return (this._instance = this._instance || new EditorPanelObjectMaskStoreControllerClass());
	}

	private constructor() {}

	private _paramId: Ref<CoreGraphNodeId | null> = ref(null);

	// getters
	paramId(): CoreGraphNodeId | null {
		return this._paramId.value;
	}

	// mutations
	open(options: EditorPanelObjectMaskOptions): void {
		this._paramId.value = options.param.graphNodeId();
	}
	close() {
		this._paramId.value = null;
	}
}

export const EditorPanelObjectMaskStoreController = EditorPanelObjectMaskStoreControllerClass.instance();
